import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { StepWizard, type Step } from '../../shared/StepWizard';
import { helloWorldDefaults, helloWorldSchema, type HelloWorldValues } from './schema';
import { Step1 } from './steps/Step1';
import { Step2 } from './steps/Step2';
import { Step3 } from './steps/Step3';

const steps: Step[] = [
  { id: 'name', label: 'Your name', component: Step1, fields: ['firstName', 'lastName'] },
  { id: 'email', label: 'Your email', component: Step2, fields: ['email', 'newsletter'] },
  { id: 'review', label: 'Review', component: Step3 },
];

/**
 * Sample flow used to validate the scaffolding end-to-end. It demonstrates:
 *
 *   - Zod schema + `react-hook-form` integration
 *   - URL-per-step routing (`/flows/hello-world/:stepId`)
 *   - Step-scoped validation before advancing
 *   - Final submit handing the result back through the bridge
 */
export const HelloWorldFlow: React.FC = () => {
  const methods = useForm<HelloWorldValues>({
    resolver: zodResolver(helloWorldSchema),
    mode: 'onBlur',
    defaultValues: helloWorldDefaults,
  });

  return (
    <FormProvider {...methods}>
      <StepWizard flowId="hello-world" steps={steps} />
    </FormProvider>
  );
};
